export default {
  '1': '番剧',
  '2': '音频',
  '3': '游戏中心',
  '4': '会员购',
  '5': '漫画',
  '6': '下载APP',
  '7': '扫码下载手机客户端',
  '8': '创作中心',
  '9': '视频投稿',
  '10': '音频投稿',
  '11': '专栏投稿',
  '12': '直播历史',
  '13': '视频',
  '14': '视频历史',
  '15': '专栏',
  '16': '专栏历史',
  '17': '全部历史',
  '18': '注册',
  '19': '登录',
  '20': '登录后你可以',
  '21': '点我注册',
  '22': '等级',
  '23': '答题转正直升',
  '24': '作为',
  '25': '会员等级相关说明',
  '26': '登录奖励',
  '27': '绑定手机可领取每日硬币',
  '28': '关注',
  '29': '粉丝',
  '30': '动态',
  '31': '退出',
  '32': [
    '成为正式会员,你可以：<br/>1、发射个性弹幕<br/>2、参与视频评论<br/>3、登入获得硬币<br/>4、投稿成为偶像',
    '1、发射滚动弹幕<br/>2、投稿成为偶像',
    '1、发射个性弹幕（彩色、高级）<br/>2、参与视频互动（评论）<br/>3、投稿成为偶像',
    '1、发射个性弹幕（彩色、高级、顶部、底部）<br/>2、参与视频互动（评论、添加tag）<br/>3、投稿成为偶像',
    '1、发射个性弹幕（彩色、高级、顶部、底部）<br/>2、参与视频互动（评论、添加tag）<br/>3、投稿成为偶像',
    '1、购买邀请码（1个/月）<br/>2、发射个性弹幕（彩色、高级、顶部、底部）<br/>3、参与视频互动（评论、添加tag）<br/>4、投稿成为偶像',
    '1、购买邀请码（2个/月）<br/>2、发射个性弹幕（彩色、高级、顶部、底部）<br/>3、参与视频互动（评论、添加tag）<br/>4、投稿成为偶像',
  ],
  '33': '个人中心',
  '34': 'B币钱包',
  '35': '订单中心',
  '36': '我的店铺',
  '37': '会员',
  '38': '主站',
  '39': '直播',
  '40': '投稿',
  '41': '投稿管理',
  '42': '直播中心',
  '43': '历史搜索',
  '44': '关键字',
  '45': '历史',
  '46': '首页',
  '47': '排行榜',
  '48': '好像最近没有看过',
  '49': '稍后再看',
  '50': '语言',
  '51': '查看全部',
  '52': '播放全部',
  '53': '你可以',
  '54': '该收藏夹还没有视频哦~',
  '55': '首次使用',
  '56': '直播中',
  '57': '未开播',
  '58': '更早',
  '59': '精彩推荐',
  '60': '大会员可畅享各种专属内容，还有游戏礼包、个性装扮等你来拿~',
  '61': '开通大会员',
  '62': '续期大会员',
  '63': '你的大会员',
  '64': '天后就要过期啦～',
  '65': '你的大会员今天过期啦～',
  '66': '你的大会员已经过期',
  '67': '天啦～',
  '68': '代金券',
  '69': '赛事',
  '70': '收藏',
  '71': '消息',
  '72': '我的课程',
  '73': '大会员',
  '74': '你无法享受特权',
  '75': '硬币',
  '76': 'B币',
  '77': '已绑定',
  '78': '前去绑定邮箱',
  '79': '前去绑定手机',
  '80': '频道',
  '81': '热门',
  '82': '贴纸投稿'
}
